<div class="filter-content gap-4 mb-5">
  <div class="sorted filter">
    <div class="dropdown">
      <button type="button" data-bs-toggle="dropdown" aria-expanded="false" class="btn btn-secondary dropdown-toggle"
        [ngbTooltip]="'Add Filters'" tooltipClass="custom-tooltip">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M17.5 3.25H2.5L8.5 10.345V15.25L11.5 16.75V10.345L17.5 3.25Z" stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <!-- Add Filters
        <span class="plus">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 4.75V15.25" stroke="#36394A" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M4.75 10H15.25" stroke="#36394A" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span> -->
      </button>
      <ul class="dropdown-menu">
        <li>
          <p (click)="clearAllFilters()" class="d-flex align-items-center justify-content-between cursor-pointer"
            role="button">
            Clear filters
            <button type="button" class="btn p-0 border-0">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M11.6004 4.39844L4.40039 11.5984M4.40039 4.39844L11.6004 11.5984" stroke="#DF1C41"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.6004 4.39844L4.40039 11.5984M4.40039 4.39844L11.6004 11.5984"
                    stroke="url(#paint0_linear_2177_612263)" stroke-opacity="0.16" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <defs>
                    <linearGradient id="paint0_linear_2177_612263" x1="8.00039" y1="4.39844" x2="8.00039" y2="11.5984"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="white" stop-opacity="0" />
                      <stop offset="1" stop-color="white" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
            </button>
          </p>
        </li>
        <li *ngFor="let item of filterType" (click)="addFiltertype(item)"><a class="dropdown-item">{{item.type}}</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="sorted filter" *ngFor="let filter of availableFilter">
    <div class="dropdown">
      <button type="button" data-bs-toggle="dropdown" aria-expanded="false" class="btn btn-secondary dropdown-toggle">
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922" stroke="#36394A" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </span>
        <div class="text-max-w">

          {{filter.type}}:{{getFilterValue(filter.type)}}
        </div>
        <span class="plus">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 4.75V15.25" stroke="#36394A" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M4.75 10H15.25" stroke="#36394A" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </button>
      <ul class="dropdown-menu">
        <li>
          <p (click)="removeFilter(filter.type)"
            class="d-flex align-items-center justify-content-between cursor-pointer" role="button">
            {{getFilterValue(filter.type) || "Clear Filter"}} <button type="button" class="btn p-0 border-0">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M11.6004 4.39844L4.40039 11.5984M4.40039 4.39844L11.6004 11.5984" stroke="#DF1C41"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.6004 4.39844L4.40039 11.5984M4.40039 4.39844L11.6004 11.5984"
                    stroke="url(#paint0_linear_2177_612263)" stroke-opacity="0.16" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <defs>
                    <linearGradient id="paint0_linear_2177_612263" x1="8.00039" y1="4.39844" x2="8.00039" y2="11.5984"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="white" stop-opacity="0" />
                      <stop offset="1" stop-color="white" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
            </button>
          </p>
        </li>
        <li *ngIf="filter.showDropDown && filter.dropDownList" (click)="$event.stopPropagation()">
          <ng-select #itemSelect name="role" id="userRole" #role [items]="filter.dropDownList" bindLabel="name"
            [virtualScroll]="true" [clearable]="true" [searchable]="true" bindValue="id"
            (change)="onSearch($event, filter.type, true)" (scrollToEnd)="loadMore.emit(filter.type)"
            (search)="searchDropDown.emit({ type: filter.type, term: $event.term })"
            (clear)="onClear(itemSelect, filter.type)" (close)="onClear(itemSelect, filter.type)">
          </ng-select>
        </li>
        <li *ngIf="!filter.showDropDown">
          <div class="position-relative">
            <span class="search-icon"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                fill="none">
                <path
                  d="M16.7499 16.75L13.4874 13.4875M15.25 9.25C15.25 12.5637 12.5637 15.25 9.25 15.25C5.93629 15.25 3.25 12.5637 3.25 9.25C3.25 5.93629 5.93629 3.25 9.25 3.25C12.5637 3.25 15.25 5.93629 15.25 9.25Z"
                  stroke="#818898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </span>
            <input #inputValue (input)="onSearch(inputValue.value, filter.type)" type="text" id="searchUsers"
              placeholder="Search" class="form-control search-control  input-max-w">
          </div>
        </li>
      </ul>
    </div>
  </div>

  <button *ngIf="availableFilter.length" (click)="clearAllFilters()" type="button"
    class="btn btn-secondary text-danger ms-auto" [ngbTooltip]="'Clear All Filters'" tooltipClass="custom-tooltip">
    <!-- Clear all filters 
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
        <path d="M11.6004 4.39844L4.40039 11.5984M4.40039 4.39844L11.6004 11.5984" stroke="currentColor"
          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M11.6004 4.39844L4.40039 11.5984M4.40039 4.39844L11.6004 11.5984"
          stroke="url(#paint0_linear_2177_612263)" stroke-opacity="0.16" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
        <defs>
          <linearGradient id="paint0_linear_2177_612263" x1="8.00039" y1="4.39844" x2="8.00039" y2="11.5984"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="white" stop-opacity="0" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
        </defs>
      </svg>
    </span> -->
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M3.25 5.5H4.75H16.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M7 5.5V4C7 3.60218 7.15804 3.22064 7.43934 2.93934C7.72064 2.65804 8.10218 2.5 8.5 2.5H11.5C11.8978 2.5 12.2794 2.65804 12.5607 2.93934C12.842 3.22064 13 3.60218 13 4V5.5M15.25 5.5V16C15.25 16.3978 15.092 16.7794 14.8107 17.0607C14.5294 17.342 14.1478 17.5 13.75 17.5H6.25C5.85218 17.5 5.47064 17.342 5.18934 17.0607C4.90804 16.7794 4.75 16.3978 4.75 16V5.5H15.25Z"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </span>
  </button>
</div>